// extracted by mini-css-extract-plugin
export default {"melodyVideo":"ON-z","isFullWidth":"PN-z","landingPageVideo":"QN-z","play":"RN-z","iframeVideo":"SN-z","playHidden":"TN-z","fullwidth":"UN-z"};